// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grundlagen: Reset, Typografie, Formulare. Farben/Schriften kommen aus styles/dark-mode.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Mobile touch optimizations */
button, a, input, select, textarea {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

body {
  font-family: var(--font-body);
  font-size: 1.0625rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  color: var(--text-primary);
  background-color: var(--bg-primary);
  touch-action: manipulation;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.main-content {
  flex: 1;
  padding-top: var(--header-height);
}

/* Typografie */
h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  line-height: 1.25;
  color: var(--text-primary);
  text-wrap: balance;
  /* Lange deutsche Komposita (z. B. "Wetterdatenanbieter") dürfen mobil nicht überlaufen */
  overflow-wrap: break-word;
  hyphens: auto;
}

h1, h2 {
  font-family: var(--font-display);
  letter-spacing: 0.005em;
}

h1 {
  font-size: clamp(2rem, 6vw, 3rem);
  line-height: 1.05;
}

h2 {
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 600;
  line-height: 1.1;
  text-transform: uppercase;
}

h3 {
  font-size: 1.15rem;
}

h4 {
  font-size: 1.05rem;
}

p {
  margin-bottom: 1rem;
  color: var(--text-secondary);
}

a {
  color: var(--accent-primary);
  text-decoration: none;
  text-underline-offset: 3px;
  transition: color 0.2s ease;
}

a:hover {
  color: var(--accent-hover);
}

code, kbd, samp {
  font-family: var(--font-mono);
  font-size: 0.88em;
}

/* Buttons */
button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Formulare */
input, textarea, select {
  font-family: inherit;
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-sm);
  padding: 0.75rem 1rem;
  font-size: 1rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

input::placeholder, textarea::placeholder {
  color: var(--text-tertiary);
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

/* Utility Classes */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }

  /* Größere Touch-Ziele für Bedienelemente (nicht für Links im Fließtext) */
  button, input, select, textarea {
    min-height: 44px;
  }
}

/* Laden & Fehler */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
  text-align: center;
  padding: 2rem;
}

.loading-container p {
  font-family: var(--font-mono);
  font-size: 0.8rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: repeating-conic-gradient(var(--accent-primary) 0 2deg, transparent 2deg 15deg);
  -webkit-mask: radial-gradient(circle, transparent 62%, #000 63%);
  mask: radial-gradient(circle, transparent 62%, #000 63%);
  animation: spin 2.4s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container h2 {
  color: var(--error);
  margin: 0;
}

.error-container p {
  color: var(--text-secondary);
  margin: 0;
}

/* Barrierefreiheit */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  html {
    scroll-behavior: auto;
  }
}

/* Sichtbarer Fokus bei Tastaturbedienung */
button:focus-visible,
a:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible,
[tabindex]:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* Druck */
@media print {
  .header,
  .footer,
  .purchase-btn,
  .menu-toggle {
    display: none !important;
  }

  .main-content {
    padding-top: 0;
  }

  body {
    background: white;
    color: black;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,+FAA+F;AAC/F;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,yFAAyF;EACzF,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,yCAAyC;EACzC,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe,kBAAkB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,cAAc,iBAAiB,EAAE;;AAEjC;EACE;IACE,eAAe;EACjB;;EAEA,0EAA0E;EAC1E;IACE,gBAAgB;EAClB;AACF;;AAEA,mBAAmB;AACnB;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0FAA0F;EAC1F,gEAAgE;EAChE,wDAAwD;EACxD,oCAAoC;AACtC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,2CAA2C;AAC3C;;;;;;EAME,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;AACF","sourcesContent":["/* Grundlagen: Reset, Typografie, Formulare. Farben/Schriften kommen aus styles/dark-mode.css */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Mobile touch optimizations */\nbutton, a, input, select, textarea {\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nbody {\n  font-family: var(--font-body);\n  font-size: 1.0625rem;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.6;\n  color: var(--text-primary);\n  background-color: var(--bg-primary);\n  touch-action: manipulation;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.main-content {\n  flex: 1;\n  padding-top: var(--header-height);\n}\n\n/* Typografie */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 700;\n  line-height: 1.25;\n  color: var(--text-primary);\n  text-wrap: balance;\n  /* Lange deutsche Komposita (z. B. \"Wetterdatenanbieter\") dürfen mobil nicht überlaufen */\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n\nh1, h2 {\n  font-family: var(--font-display);\n  letter-spacing: 0.005em;\n}\n\nh1 {\n  font-size: clamp(2rem, 6vw, 3rem);\n  line-height: 1.05;\n}\n\nh2 {\n  font-size: clamp(1.5rem, 4vw, 2rem);\n  font-weight: 600;\n  line-height: 1.1;\n  text-transform: uppercase;\n}\n\nh3 {\n  font-size: 1.15rem;\n}\n\nh4 {\n  font-size: 1.05rem;\n}\n\np {\n  margin-bottom: 1rem;\n  color: var(--text-secondary);\n}\n\na {\n  color: var(--accent-primary);\n  text-decoration: none;\n  text-underline-offset: 3px;\n  transition: color 0.2s ease;\n}\n\na:hover {\n  color: var(--accent-hover);\n}\n\ncode, kbd, samp {\n  font-family: var(--font-mono);\n  font-size: 0.88em;\n}\n\n/* Buttons */\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\nbutton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Formulare */\ninput, textarea, select {\n  font-family: inherit;\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-sm);\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\ninput::placeholder, textarea::placeholder {\n  color: var(--text-tertiary);\n}\n\ninput:focus, textarea:focus, select:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n/* Utility Classes */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n@media (max-width: 768px) {\n  .container {\n    padding: 0 1rem;\n  }\n\n  /* Größere Touch-Ziele für Bedienelemente (nicht für Links im Fließtext) */\n  button, input, select, textarea {\n    min-height: 44px;\n  }\n}\n\n/* Laden & Fehler */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 1rem;\n  text-align: center;\n  padding: 2rem;\n}\n\n.loading-container p {\n  font-family: var(--font-mono);\n  font-size: 0.8rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: repeating-conic-gradient(var(--accent-primary) 0 2deg, transparent 2deg 15deg);\n  -webkit-mask: radial-gradient(circle, transparent 62%, #000 63%);\n  mask: radial-gradient(circle, transparent 62%, #000 63%);\n  animation: spin 2.4s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-container h2 {\n  color: var(--error);\n  margin: 0;\n}\n\n.error-container p {\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* Barrierefreiheit */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n\n  html {\n    scroll-behavior: auto;\n  }\n}\n\n/* Sichtbarer Fokus bei Tastaturbedienung */\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\ntextarea:focus-visible,\nselect:focus-visible,\n[tabindex]:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n/* Druck */\n@media print {\n  .header,\n  .footer,\n  .purchase-btn,\n  .menu-toggle {\n    display: none !important;\n  }\n\n  .main-content {\n    padding-top: 0;\n  }\n\n  body {\n    background: white;\n    color: black;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
